/**
 *
 * @file 页面：企业中心/我的方案/企业方案
 * @author xiongwei_zhang <xiongwei_zhang@foxitsoftware.com>
 *
 **/

import {
    Pagination,
    Empty,
    Input,
    Select,
    Modal,
    message,
    Menu,
    Button,
    Checkbox,
    Space,
    Spin,
    Tooltip,
} from 'antd';
import { useReducer } from 'react';
import { useHistory } from 'react-router-dom';
import { useStoreState } from '&/utils/customHooks';
import BasePageWrap from '&/components/ResourceLib/BasePageWrap';
import emptyIcon from '&/assets/img/userCenter/emptyydata-object.png';
import failIcon from '&/assets/img/userCenter/fail.png';
import DecorationCard4B from '&/components/ProjectSpace/DecorationCard4B';
import warningIcon from '&/assets/img/userCenter/warnimg.png';
import EditScheme from '&/pages/user-center/EditScheme';
import DateRange from '&/components/DateRange';
import SvgIcon from '&/components/SvgIcon';
import {
    getDecorations,
    manipulateDecorations,
} from '&/api/personCenter/decoration';
import { getDesignStyle } from '&/api/home';
import LabelFilter from '&/components/ProjectSpace/LabelFilter';
import OrganizationTree from './organizationTree.js';
import './index.scss';

function EnterpriseDecoration() {
    const [queryForm, setQueryForm] = useState({
        status: 0,
        date: null,
        tab: 0,
        sort: +localStorage.getItem('schemeDateSortType') || 1,
        page: 1,
        pageNum: 20,
        entId: null,
        keyword: '',
        case: false,
        cliqueType: 2,
    });
    const [counter, reloadList] = useReducer(s => s + 1, 0);

    const onChangeParam = (key, val, isUpdate = true) => {
        if (key.toString() === '[object Object]') {
            setQueryForm(prev => ({ ...prev, ...key }));
            return reloadList();
        }
        setQueryForm(prev => ({ ...prev, page: 1, [key]: val }));
        if (key === 'sort') localStorage.setItem('schemeDateSortType', val);
        if (!isUpdate) return;
        reloadList();
    };

    const [styleList, setStyleList] = useState([]);
    useEffect(() => {
        getDesignStyle({ entId: undefined }).then(({ data }) => {
            setStyleList(data);
            // const tags = data.map(e => ({ value: e.id, label: e.name }));
        });
    }, []);

    const onLabelFilterChange = filterList => {
        const params = {};
        if (filterList.value) {
            const { value } = filterList;
            if (value.area) {
                params.inner = value.area.map(item => item?.split('-'));
            }
            if (value.houseType) {
                params.houseNum = value.houseType;
            }
            if (value.style) {
                params.form = value.style;
            }
        }
        onChangeParam(params);
    };

    const [loading, setLoading] = useState(false);
    const [schemeList, setSchemeList] = useState([]);
    const [total, setTotal] = useState(0);

    async function queryList() {
        if (counter < 1) return; // 初始化不请求。等企业参数提供后，再请求
        try {
            setLoading(true);
            const PAYLOAD = {
                ...queryForm,
                case: queryForm.case ? 1 : null,
                date: queryForm.date?.map(el => el.unix()),
            };
            const { data } = await getDecorations(PAYLOAD);
            setSchemeList(data.list);
            setTotal(data.page?.totalList || 0);
        } finally {
            setLoading(false);
        }
    }

    useEffect(queryList, [counter]);

    const nameFilter = (
        <>
            <Input
                allowClear
                suffix={
                    <i
                        className="icon-search filled pointer"
                        style={{ fontSize: '0.75rem' }}
                        onClick={reloadList}
                    />
                }
                style={{
                    width: '10rem',
                }}
                placeholder={intl.get('decorationScheme.label.name')}
                value={queryForm.keyword}
                onPressEnter={reloadList}
                onChange={e => onChangeParam('keyword', e.target.value, false)}
            />
        </>
    );

    const appStore = useStoreState('appStore'),
        { organization = {} } = appStore,
        isAdmin = organization?.roleFlag === 'admin';

    const sortOptions = [
        {
            label: intl.get('decorationScheme.sortType.reverseCreateTimeOrder'),
            value: 1,
        },
        {
            label: intl.get('decorationScheme.sortType.createTimeOrder'),
            value: 2,
        },
        {
            label: intl.get('decorationScheme.sortType.reverseUpdateTimeOrder'),
            value: 3,
        },
        {
            label: intl.get('decorationScheme.sortType.updateTimeOrder'),
            value: 4,
        },
    ];

    const [isBatch, setIsBatch] = useState(false);
    const [checkedValues, setCheckedValues] = useState([]);
    const [checkedAll, setCheckedAll] = useState(false);

    const onSelectAll = e => {
        const { checked } = e.target;
        setCheckedValues(checked ? schemeList.map(e => e.id) : []);
        setCheckedAll(checked);
    };

    const onCheckCards = val => {
        setCheckedValues(val);
        setCheckedAll(schemeList.length && val.length === schemeList.length);
    };

    const onCancel = () => {
        setIsBatch(false);
        onCheckCards([]);
    };

    const multipleMark = CASE => {
        if (!checkedValues.length)
            return message.warn(intl.get('decorationScheme.multiple.none'));
        let updateIdxs = [];
        const schemeIds = [];
        for (let index = 0; index < schemeList.length; index++) {
            const element = schemeList[index];
            if (
                checkedValues.includes(element.id) &&
                1 - element.case === CASE
            ) {
                schemeIds.push(element.id);
                updateIdxs.push(index);
            }
        }
        if (!schemeIds.length) return message.warn('选中的案例均不支持此操作');

        manipulateDecorations({
            dap: 1,
            schemeIds,
        }).then(() => {
            message.success(
                CASE > 0
                    ? intl.get('decorationScheme.multiple.isMarked')
                    : intl.get('decorationScheme.multiple.isCancel')
            );
            setSchemeList(prev => {
                const next = [...prev];
                for (let i = 0; i < updateIdxs.length; i++) {
                    const index = updateIdxs[i];
                    next[index].case = CASE;
                }
                updateIdxs = [];
                return next;
            });
            onCheckCards([]);
        });
    };

    const multipleDel = () => {
        if (!checkedValues.length) return message.warn('未选中案例');
        const modal = Modal.confirm({
            title: intl.get('decorationScheme.deleteConfirm.multipleTitle', {
                num: checkedValues.length,
            }),
            content: intl.get('decorationScheme.deleteConfirm.description'),
            ...MODAL_OPTIONS,
            onOk: async () => {
                try {
                    modal.update({ okButtonProps: { loading: true } });

                    const { msg } = await manipulateDecorations({
                        dap: 3,
                        schemeIds: checkedValues,
                    });
                    if (
                        queryForm.page > 1 &&
                        checkedValues.length === +queryForm.pageNum
                    ) {
                        onChangeParam('page', queryForm.page - 1);
                    } else {
                        reloadList();
                    }
                    message.success(msg);
                    onCheckCards([]);
                } finally {
                    modal.update({ okButtonProps: { loading: false } });
                }
            },
        });
    };

    const batchOperation = isBatch ? (
        <>
            <Checkbox
                onChange={onSelectAll}
                checked={checkedAll}
                indeterminate={
                    checkedValues.length &&
                    schemeList.length > checkedValues.length
                }>
                {intl.get('base.checkAll')}
            </Checkbox>
            <Button onClick={() => multipleMark(1)}>
                {intl.get('decorationScheme.mark')}
            </Button>
            <Button onClick={() => multipleMark(0)}>
                {intl.get('decorationScheme.cancelMark')}
            </Button>
            <Button onClick={multipleDel}>{intl.get('base.delete')}</Button>
            <Button onClick={onCancel}>{intl.get('base.cancel')}</Button>
        </>
    ) : (
        <Button disabled={!isAdmin} onClick={() => setIsBatch(true)}>
            {intl.get('base.batchOperation')}
        </Button>
    );

    const sortSelect = (
        <Select
            className="sort-select"
            value={queryForm.sort}
            options={sortOptions}
            onChange={e => onChangeParam('sort', e)}
            suffixIcon={<i className="icon-arrow-down outlined" />}
            bordered={false}
        />
    );

    const history = useHistory();

    const go2Detail = scheme => {
        history.push(
            `/user-center/enterprise-decoration/decoration-design/${scheme.id}?is_ent=1`
        );
    };

    const [visible, setVisible] = useState(false);
    const detail = useRef();

    const markAsCase = (single, index) => {
        manipulateDecorations({
            dap: 1,
            schemeIds: [single.id],
        }).then(() => {
            message.success(
                single.case > 0 ? '已取消标记案例' : '已标记为案例'
            );
            setSchemeList(prev => {
                const next = [...prev];
                next[index].case = 1 - single.case;
                return next;
            });
        });
    };

    const MODAL_OPTIONS = {
        icon: <img src={warningIcon} alt="warning" className="confirm-icon" />,
        width: 350,
        className: 'confirm-modal',
        okText: intl.get('base.confirm'),
        cancelText: intl.get('base.cancel'),
        centered: true,
        okButtonProps: { loading: false },
    };

    const deleteScheme = single => {
        const modal = Modal.confirm({
            title: intl.get('decorationScheme.deleteConfirm.title'),
            content: intl.get('decorationScheme.deleteConfirm.description'),
            ...MODAL_OPTIONS,
            onOk: async () => {
                try {
                    modal.update({ okButtonProps: { loading: true } });
                    const { msg } = await manipulateDecorations({
                        dap: 3,
                        schemeIds: [single.id],
                    });
                    message.success(msg);
                    reloadList();
                } finally {
                    modal.update({ okButtonProps: { loading: false } });
                }
            },
        });
    };

    const [delList, setDelList] = useState([]);

    const methods = {
        edit(scheme) {
            detail.current = scheme;
            setVisible(true);
        },
        delete: deleteScheme,
        update(single) {
            const modal = Modal.confirm({
                title: intl.get('decorationScheme.updateTitle'),
                content: intl.get('decorationScheme.updateWarn'),
                ...MODAL_OPTIONS,
                onOk: async () => {
                    modal.update({ okButtonProps: { loading: true } });
                    try {
                        await manipulateDecorations(
                            {
                                dap: 4,
                                schemeIds: [single.id],
                            },
                            10001
                        );
                        message.success(
                            intl.get('decorationScheme.updateSuccess')
                        );
                        queryList();
                    } catch (error) {
                        if (error.code === 10001) {
                            setDelList(prev => prev.concat([single.id]));

                            Modal.error({
                                width: 300,
                                className: 'confirm-modal',
                                icon: (
                                    <img
                                        src={failIcon}
                                        alt="warning"
                                        className="confirm-icon"
                                    />
                                ),
                                title: intl.get('decorationScheme.updateFail'),
                                content: error.msg,
                                okButtonProps: { type: 'default' },
                                okText: intl.get('decorationScheme.know'),
                                centered: true,
                            });
                        }
                    } finally {
                        modal.update({ okButtonProps: { loading: false } });
                    }
                },
            });
        },
        mark: markAsCase,
    };

    const clickMenuHandler = (e, item, idx) => {
        methods[e.key](item, idx);
    };

    const adminMenuProps = item => [
        {
            id: 'edit',
            label: intl.get('decorationScheme.menu.edit'),
        },
        delList.includes(item.id)
            ? undefined
            : {
                  id: 'update',
                  label: intl.get('decorationScheme.menu.update'),
              },
        {
            id: 'mark',
            label: item.case > 0 ? '取消标记案例' : '标记为案例',
        },
        {
            id: 'delete',
            label: intl.get('decorationScheme.menu.delete'),
        },
    ];

    const cardRender = (item, idx) => {
        const { id, case: itemCase } = item;
        return (
            <DecorationCard4B
                className="scheme-item"
                key={id}
                checkable={isBatch}
                showProfile
                checked={checkedValues.includes(id)}
                isShowTag
                value={item}
                go2Detail={go2Detail}
                dateType={+(queryForm.sort > 2)}
                extra={
                    isAdmin ? (
                        <Tooltip
                            title={
                                itemCase > 0 ? '取消标记案例' : '标记为案例'
                            }>
                            <SvgIcon
                                iconName={
                                    itemCase > 0 ? 'markActive' : 'markDefault'
                                }
                                onClick={() => markAsCase(item, idx)}
                                className="mark-icon"
                            />
                        </Tooltip>
                    ) : (
                        itemCase > 0 && (
                            <Tooltip title={'方案'}>
                                <SvgIcon
                                    iconName="markActive"
                                    className="mark-icon"
                                />
                            </Tooltip>
                        )
                    )
                }
                menuRender={() =>
                    isAdmin && (
                        <Menu onClick={e => clickMenuHandler(e, item, idx)}>
                            {adminMenuProps(item).map(menuItem =>
                                !menuItem ? (
                                    menuItem
                                ) : (
                                    <Menu.Item key={menuItem.id}>
                                        {menuItem.label}
                                    </Menu.Item>
                                )
                            )}
                        </Menu>
                    )
                }
            />
        );
    };

    return (
        <BasePageWrap
            className="enterprise-decoration "
            type="card"
            title={
                <div className="page-title">
                    {intl.get('userCenterSidebar.enterpriseDecoration')}
                    <div className="design-num">{total}</div>
                </div>
            }>
            <OrganizationTree onChange={onChangeParam} />
            <div className="list-container">
                <div className="params-wrap">
                    <Space size={8}>
                        <Checkbox
                            value={queryForm.case}
                            onChange={e =>
                                onChangeParam('case', e.target.checked)
                            }>
                            {intl.get('decorationScheme.onlyView')}
                        </Checkbox>

                        <LabelFilter
                            wrapClass="list-container"
                            area={queryForm.inner?.map(item => item.join('-'))}
                            houseType={queryForm.houseNum}
                            houseStyle={queryForm.form}
                            houseTypeList={styleList}
                            onConfirmFilterHandler={onLabelFilterChange}
                        />

                        <DateRange
                            onChange={val => onChangeParam('date', val)}
                            value={queryForm.date}
                        />
                        <div className="divider" />
                        {sortSelect}
                    </Space>
                    <Space className="right-content-wrap" size={16}>
                        {nameFilter}
                        <div className="divider" />
                        {batchOperation}
                    </Space>
                </div>
                <Spin spinning={loading}>
                    <Checkbox.Group
                        onChange={onCheckCards}
                        value={checkedValues}>
                        <div className="enterprise-decoration-list-wrap">
                            {schemeList.length === 0 ? (
                                <Empty
                                    image={emptyIcon}
                                    imageStyle={{
                                        height: 160,
                                        marginTop: '10%',
                                    }}
                                    description={
                                        <div className="hint-message">
                                            暂无方案
                                        </div>
                                    }
                                />
                            ) : (
                                schemeList.map(cardRender)
                            )}
                        </div>
                        <Pagination
                            size="small"
                            current={queryForm.page}
                            onChange={e => onChangeParam('page', e)}
                            total={total}
                            pageSize={queryForm.pageNum}
                            showTotal={total =>
                                intl.get('base.total', { total })
                            }
                        />
                    </Checkbox.Group>
                </Spin>
                <EditScheme
                    detailData={detail.current}
                    visible={visible}
                    setVisible={setVisible}
                    styleList={styleList}
                    submitCb={reloadList}
                />
            </div>
        </BasePageWrap>
    );
}

export default EnterpriseDecoration;
